import React, { useEffect, useState } from 'react'

import { TRACKING_MAPPING } from '@js/common/constants'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const FormCheckbox = ({
  formElement,
  defaultChecked = false,
  checked = undefined,
  label = null,
  name = null,
  className = null,
  onChange = () => {},
  onFocus = () => {},
  onBlur = () => {},
  checkboxValue = null,
  theme = null,
  inputProps = null,
  labelClassNames = null,
  description = null,
  descriptionClassNames = null,
  toggledDescription = null,
  image = {},
  groupId = '',
  validation = null,
  formElements = null,
  setFormElements = () => {},
  checkedIcon = null,
  ItemTemplate = null,
  wtData = {},
  ...props
}) => {
  const [localChecked, setLocalChecked] = useState(
    checked !== undefined ? checked : !!defaultChecked
  )
  const [displayError, setDisplayError] = useState(null)
  const [isValidating, setIsValidating] = useState(false)
  const [descriptionVisible, setDescriptionVisible] = useState(false)

  useEffect(() => {
    if (checked !== undefined) {
      setLocalChecked(checked)

      if (validation) {
        validate(checked)
      }
    }
  }, [checked])

  useEffect(() => {
    if (setFormElements) {
      setFormElements({
        name,
        value: localChecked,
        invalidRule: ''
      })
    }

    if (validation) {
      validate(localChecked)
    }
  }, [localChecked])

  const validate = checked => {
    let valueToCheck = checked ? checked : localChecked

    validationLoop: for (const validationItem of validation) {
      if (!checkValidation(validationItem, valueToCheck)) break validationLoop
    }
  }

  const trackClick = () => {
    _wt({
      category: 'checkbox',
      action: 'click',
      values: [
        {
          type:
            TRACKING_MAPPING[name] && TRACKING_MAPPING[name].label
              ? TRACKING_MAPPING[name].label
              : name,
          value: wtData.valueOverride ? wtData.valueOverride : label
        }
      ],
      ...(wtData['checkbox'] ? wtData['checkbox'] : {})
    })
  }

  const handleToggle = () => {
    setDescriptionVisible(() => !descriptionVisible)
  }

  const onInputChange = event => {
    setLocalChecked(checkStatus => {
      trackClick()
      onChange(event, { name, value: !checkStatus, groupId })
      return !checkStatus
    })
  }

  useEffect(() => {
    if (validation) {
      validate()
    }
  }, [])

  const onInputBlur = event => {
    if (validation) {
      setIsValidating(true)
      validate()
    }

    if (onBlur) {
      onBlur(event)
    }
  }

  const onInputFocus = event => {
    if (onFocus) {
      onFocus(event)
    }
  }

  const propsToTemplate = {
    label,
    image
  }

  const checkValidation = (validationItem, currentValue) => {
    if (validationItem.rule === 'not-checked' && currentValue === false) {
      setFormElements({
        name,
        invalidRule: validationItem.rule
      })
      setDisplayError(validationItem.message)
      return false
    } else {
      setFormElements({
        name,
        value: currentValue,
        invalidRule: ''
      })
      setDisplayError(null)
      return true
    }
  }

  return (
    <>
      <label
        className={`FormCheckbox-wrapper ${
          theme ? `FormCheckbox-wrapper-${theme}` : ''
        } ${/form/.test(theme) ? 'f-p-l-040' : ''} ${
          className ? className : ''
        } ${localChecked ? 'is-checked' : ''}
      }`}
        {...props}>
        <input
          type='checkbox'
          className='FormCheckbox'
          checked={localChecked}
          name={name}
          value={checkboxValue}
          onClick={onInputChange}
          onFocus={onInputFocus}
          onBlur={onInputBlur}
          readOnly={!inputProps?.onChange}
          {...inputProps}
        />
        {ItemTemplate ? (
          <ItemTemplate {...propsToTemplate} isActive={localChecked} />
        ) : (
          <>
            {/form/.test(theme) && (
              <span className='[ f-pos-rel ] FormCheckbox-square'>
                {localChecked ? (
                  <Icon
                    icon='check-16px'
                    className={
                      '[ f-icon-030 f-c-st-whi ] FormCheckbox-square-check is-checked-icon ]'
                    }
                  />
                ) : (
                  <Icon
                    icon='check-16px'
                    className='[ f-icon-030 f-c-st-neu050 ] FormCheckbox-square-check unchecked'
                  />
                )}
              </span>
            )}
            {/image-label-/.test(theme) && image.path !== null && (
              <span
                className={`${
                  /image-label-vendor/.test(theme)
                    ? '[ f-d-bl f-pos-rel ] Formcheckbox-image-wrapper'
                    : '[ f-d-bl f-pos-rel ] FormCheckbox-image'
                } `}>
                {/svg-symbol/.test(image.type) ? (
                  <svg
                    aria-hidden='true'
                    role='img'
                    focusable='false'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox={image.viewBox || '0 0 320 240'}
                    width={/image-label-small/.test(theme) ? 160 : 240}
                    height={/image-label-small/.test(theme) ? 120 : 180}
                    style={{
                      padding: /image-label-large/.test(theme) ? 24 : 0
                    }}>
                    <use xlinkHref={image.path} />
                  </svg>
                ) : image.flexLayout ? (
                  <img
                    src={image.path}
                    className={`${
                      /image-label-vendor/.test(theme)
                        ? '[ f-d-bl f-radius-card-large f-p-t-010 ] Formcheckbox-vendor-image'
                        : '[ f-d-bl f-radius-card-large ]'
                    }`}
                  />
                ) : (
                  <img
                    src={image.path}
                    width={160}
                    height={120}
                    className={`${
                      image.parameters && image.parameters.className
                        ? image.parameters.className
                        : ''
                    }`}
                    style={
                      image.parameters && image.parameters.style
                        ? image.parameters.style
                        : undefined
                    }
                  />
                )}
              </span>
            )}
            {label ? (
              <span
                className={`[ f-pos-rel ] ${
                  labelClassNames ? labelClassNames : ''
                } ${
                  /image-label-/.test(theme) && localChecked
                    ? '[ f-c-ba-pri f-c-fo-whi ]'
                    : ''
                } ${
                  /image-label-vendor/.test(theme)
                    ? '[ f-d-bl f-t-mini f-t-bold f-c-ba-whi f-c-fo-pri f-t-centre f-p-h-010 f-p-b-010 ] FormCheckbox-vendor-name'
                    : ''
                } `}>
                {label}
              </span>
            ) : (
              ''
            )}
            {description ? (
              <span
                className={`${
                  descriptionClassNames ? descriptionClassNames : ''
                } FormCheckbox-description ${
                  /image-label-/.test(theme) && localChecked
                    ? '[ f-c-ba-pri f-c-fo-whi ]'
                    : '[ f-c-fo-pri ]'
                }`}>
                {description}
              </span>
            ) : (
              ''
            )}
            {toggledDescription ? (
              <div
                className={descriptionVisible ? '[ f-m-t-010 f-p-l-005 ]' : ''}>
                <CTA
                  type='icon'
                  tag='button'
                  className='[ f-pos-ab ] FormCheckbox-description-trigger'
                  onClick={handleToggle}
                  wtData={
                    wtData.checkbox && wtData.checkbox.location
                      ? {
                          'CTA-click': {
                            location: wtData.checkbox.location
                          }
                        }
                      : {}
                  }>
                  <Icon
                    icon='down-arrow-16px'
                    className={`[ f-icon-020 f-c-st-pri ] has-animated-chevron ${
                      descriptionVisible ? 'is-switched' : ''
                    }`}
                  />
                </CTA>
                {descriptionVisible ? (
                  <div className='[ f-t-micro ]'>{toggledDescription}</div>
                ) : null}
              </div>
            ) : null}
            {checkedIcon && localChecked ? (
              <span className='[ f-c-ba-whi f-p-a-005 ] FormCheckbox-icon'>
                <Icon
                  icon={checkedIcon}
                  className='[ f-icon-020 f-c-st-ter f-d-bl ]'
                />
              </span>
            ) : (
              ''
            )}
          </>
        )}
      </label>
      {((formElements && formElements.status === 'validating') ||
        isValidating) &&
      displayError ? (
        <span className='[ f-d-bl f-t-mini f-p-a-020 f-c-fo-pri f-c-ba-war f-m-b-020 ] FormError-wrapper'>
          {displayError}
        </span>
      ) : (
        ''
      )}
    </>
  )
}

export default FormCheckbox
